// extracted by mini-css-extract-plugin
export default {"modal_content_wrap":"toMdQE6mn3gqRrzeCdam","select_wrap":"yooorE5_4Fr4h0HDy3g8","table_wrap":"sIFDw_PwGBw1bgU7Supg","default_btn_wrap":"nOgJbGAKlgf4V1xL0hsr"};